import Loading from '../../../Common/components/Loading';
import useFavorites from './hooks/useFavorites';
import '../Gallery.css';
import GalleryView from '../GalleryView';
import { createGlobalStyle } from 'styled-components';

interface DefaultThemeProps {
    foregroundColor?: string;
    backgroundColor?: string;
    headerBackgroundColor?: string;
    headerForegroundColor?: string;
}
const GlobalStyle = createGlobalStyle`
body {
        color: ${({ foregroundColor }: DefaultThemeProps) =>
            foregroundColor || '#000'};
        background-color: ${({ backgroundColor }: DefaultThemeProps) =>
            backgroundColor || '#FFF'};;
}

.Fullscreen-modal {
    color: ${({ foregroundColor }: DefaultThemeProps) =>
        foregroundColor || '#000'};
    background-color: ${({ backgroundColor }: DefaultThemeProps) =>
        backgroundColor || '#FFF'};;

}

.Share-form input {
    color: ${({ foregroundColor }: DefaultThemeProps) =>
        foregroundColor || '#000'};
    background-color: ${({ backgroundColor }: DefaultThemeProps) =>
        backgroundColor || '#FFF'};
    border-color: ${({ foregroundColor }: DefaultThemeProps) =>
        foregroundColor || '#000'};
    border-style:solid;
    font-family: 'Roboto', sans-serif;
}

.Share-form .Link-button {
    background-color: ${({ foregroundColor }: DefaultThemeProps) =>
        foregroundColor || '#000'};
    color: ${({ backgroundColor }: DefaultThemeProps) =>
        backgroundColor || '#FFF'};;
}

.SB-Modal {
    color: ${({ foregroundColor }: DefaultThemeProps) =>
        foregroundColor || '#000'};
    background-color: ${({ backgroundColor }: DefaultThemeProps) =>
        backgroundColor || '#FFF'};;
}

.Gallery-cell.expanded {
color: ${({ foregroundColor }: DefaultThemeProps) => foregroundColor || '#000'};
    background-color: ${({ backgroundColor }: DefaultThemeProps) =>
        backgroundColor || '#FFF'};;
}

.Gallery-cell.expanded > .options {
color: ${({ foregroundColor }: DefaultThemeProps) => foregroundColor || '#000'};
    background-color: ${({ backgroundColor }: DefaultThemeProps) =>
        backgroundColor || '#FFF'};;
}

.cta-button {
    background-color: ${({ foregroundColor }: DefaultThemeProps) =>
        foregroundColor || '#000'};
    color: ${({ backgroundColor }: DefaultThemeProps) =>
        backgroundColor || '#FFF'};
    }

.Gallery-header {
    background-color: ${({ headerBackgroundColor }: DefaultThemeProps) =>
        headerBackgroundColor || '#000'};
    color: ${({ headerForegroundColor }: DefaultThemeProps) =>
        headerForegroundColor || '#FFF'};
}

.Gallery-name {
    color: ${({ headerForegroundColor }: DefaultThemeProps) =>
        headerForegroundColor || '#FFF'};
}

.Find-your-own-photos-banner {
    background-color: ${({ headerBackgroundColor }: DefaultThemeProps) =>
        headerBackgroundColor || '#000'};
    color: ${({ headerForegroundColor }: DefaultThemeProps) =>
        headerForegroundColor || '#FFF'};
}

`;

export function FavoritesGallery() {
    const {
        gallery,
        isLoading,
        photos,
        delayed,
        expandedIndex,
        setExpandedIndex,
        swipeHandlers,
        loadedPhotos,
        getNewPage,
    } = useFavorites();

    if (isLoading) {
        return <Loading isLoading={true} />;
    }

    return (
        <div className="Gallery-view">
            <GlobalStyle
                foregroundColor={gallery?.foregroundColor}
                backgroundColor={gallery?.backgroundColor}
                headerBackgroundColor={gallery?.headerBackgroundColor}
                headerForegroundColor={gallery?.headerForegroundColor}
            />
            <GalleryView
                {...{
                    gallery,
                    isLoading,
                    photos,
                    delayed,
                    expandedIndex,
                    setExpandedIndex,
                    swipeHandlers,
                    loadedPhotos,
                    getNewPage,
                    galleryId: gallery?.id || 0,
                }}
            />
        </div>
    );
}
